<template>
  <component v-if="workspaceComponent" :is="workspaceComponent" />
</template>

<script>
import { getCourseViewer } from '../utils/viewer';

export default {
  name: 'CourseWorkspace',
  components: {
    StudentWorkspace: () => import('./Student'),
    TeacherWorkspace: () => import('./Teacher'),
    AdminWorkspace: () => import('./Admin')
  },
  data: () => ({ viewer: '' }),
  computed: {
    workspaceComponent() {
      if (this.viewer === 'student') return 'StudentWorkspace';
      if (this.viewer === 'teacher') return 'TeacherWorkspace';
      if (this.viewer === 'admin') return 'AdminWorkspace';
      return '';
    }
  },
  async created() {
    this.viewer = await getCourseViewer(this);
    if (!this.workspaceComponent) {
      this.$router.replace({ name: 'course-list' });
    }
  }
};
</script>
